/* Smarty Vets — Athens theme.js
 * Sticky-nav scroll state, FAQ accordion, "/" search shortcut.
 */
(function () {
  'use strict';

  // ---------- Sticky nav: add .is-scrolled when scrollY > 8 ----------
  var nav = document.querySelector('.sv-nav');
  if (nav) {
    var setScrolled = function () {
      if (window.scrollY > 8) {
        nav.classList.add('is-scrolled');
      } else {
        nav.classList.remove('is-scrolled');
      }
    };
    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });
  }

  // ---------- FAQ accordion ----------
  document.querySelectorAll('.sv-faq').forEach(function (item) {
    var btn = item.querySelector('.sv-faq-q');
    var mark = item.querySelector('.sv-faq-mark');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (mark) mark.textContent = open ? '–' : '+';
    });
  });

  // ---------- "/" focuses formulary search ----------
  document.addEventListener('keydown', function (e) {
    if (e.key !== '/') return;
    var ae = document.activeElement;
    if (ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA' || ae.isContentEditable)) return;
    var input = document.querySelector('.sv-search-input');
    if (input) {
      e.preventDefault();
      input.focus();
    }
  });

  // ---------- Marquee duplicate (so it loops seamlessly) ----------
  document.querySelectorAll('[data-marquee-track]').forEach(function (track) {
    if (track.dataset.duplicated === '1') return;
    track.innerHTML += track.innerHTML;
    track.dataset.duplicated = '1';
  });

  // ---------- Pet wall: duplicate items for seamless loop ----------
  document.querySelectorAll('[data-petwall-track]').forEach(function (track) {
    if (track.dataset.duplicated === '1') return;
    track.innerHTML += track.innerHTML;
    track.dataset.duplicated = '1';
  });

  // ---------- Ask the Vet (Pearl AI) ----------
  var fab    = document.getElementById('sv-ask-vet-fab');
  var modal  = document.getElementById('sv-ask-vet-modal');
  var thread = document.getElementById('sv-ask-thread');
  var form   = document.getElementById('sv-ask-form');
  var input  = document.getElementById('sv-ask-input');

  function openAsk() {
    if (!modal) return;
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
    setTimeout(function () { if (input) input.focus(); }, 50);
  }
  function closeAsk() {
    if (!modal) return;
    modal.hidden = true;
    document.body.style.overflow = '';
  }

  if (fab) fab.addEventListener('click', openAsk);
  document.querySelectorAll('[data-close-ask]').forEach(function (el) {
    el.addEventListener('click', closeAsk);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) closeAsk();
  });

  // Hijack any link/button marked data-ask-vet OR pointing at /pages/start or #ask-vet
  document.addEventListener('click', function (e) {
    var t = e.target.closest('a, button');
    if (!t) return;
    var href = t.getAttribute('href') || '';
    if (t.hasAttribute('data-ask-vet') || href === '#ask-vet' || href === '/pages/start') {
      e.preventDefault();
      openAsk();
    }
  });

  var AI_AVATAR_SVG = '<svg viewBox="0 0 32 32" fill="currentColor" width="20" height="20" aria-hidden="true">' +
    '<ellipse cx="7" cy="9" rx="2.6" ry="3.6"/>' +
    '<ellipse cx="13" cy="5" rx="2.6" ry="4"/>' +
    '<ellipse cx="19" cy="5" rx="2.6" ry="4"/>' +
    '<ellipse cx="25" cy="9" rx="2.6" ry="3.6"/>' +
    '<path d="M16 14c-7 0-10 5-10 10 0 4.4 3 7.5 10 7.5s10-3.1 10-7.5c0-5-3-10-10-10z"/>' +
    '</svg>';

  function appendMessage(role, text) {
    if (!thread) return;
    var wrap = document.createElement('div');
    wrap.className = 'sv-ask-msg sv-ask-msg--' + role;
    if (role === 'ai') {
      var avatar = document.createElement('span');
      avatar.className = 'sv-ask-msg-avatar sv-ask-msg-avatar--ai';
      avatar.setAttribute('aria-hidden', 'true');
      avatar.innerHTML = AI_AVATAR_SVG;
      wrap.appendChild(avatar);
    }
    var bubble = document.createElement('div');
    bubble.className = 'sv-ask-msg-bubble';
    bubble.textContent = text;
    wrap.appendChild(bubble);
    thread.appendChild(wrap);
    thread.scrollTop = thread.scrollHeight;
    return bubble;
  }

  var conversation = [];

  if (form) form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = (input.value || '').trim();
    if (!q) return;
    appendMessage('user', q);
    input.value = '';
    conversation.push({ role: 'user', content: q });

    var sendBtn = form.querySelector('.sv-ask-send');
    var label   = form.querySelector('.sv-ask-send-label');
    var spinner = form.querySelector('.sv-ask-send-spinner');
    if (sendBtn) sendBtn.disabled = true;
    if (label) label.hidden = true;
    if (spinner) spinner.hidden = false;

    var pending = appendMessage('ai', '…');
    if (pending) pending.classList.add('sv-ask-msg-bubble--pending');

    var cfg = window.SV_PEARL || {};
    if (!cfg.apiKey) {
      pending.textContent = 'Pearl API key isn’t set yet. Open theme settings → "Ask the Vet (Pearl AI)" and paste a key.';
      if (sendBtn) sendBtn.disabled = false;
      if (label) label.hidden = false;
      if (spinner) spinner.hidden = true;
      return;
    }

    var messages = [{ role: 'system', content: cfg.systemPrompt }].concat(conversation);

    fetch(cfg.apiUrl, {
      method: 'POST',
      headers: {
        'Authorization': 'Bearer ' + cfg.apiKey,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        model: cfg.model,
        messages: messages,
        metadata: { mode: 'pearl-ai-expert' }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).then(function (data) {
      var content =
        (data.choices && data.choices[0] && data.choices[0].message && data.choices[0].message.content) ||
        data.content ||
        data.answer ||
        '(no response)';
      pending.classList.remove('sv-ask-msg-bubble--pending');
      pending.textContent = content;
      conversation.push({ role: 'assistant', content: content });
    }).catch(function (err) {
      pending.classList.remove('sv-ask-msg-bubble--pending');
      pending.textContent = 'Something went wrong reaching Pearl (' + err.message + '). Try again, or book a hands-on visit.';
    }).finally(function () {
      if (sendBtn) sendBtn.disabled = false;
      if (label) label.hidden = false;
      if (spinner) spinner.hidden = true;
    });
  });
})();
